import React, { useState, useRef, useEffect } from "react";

function SpectatorPerspectiveSelector({ players = [], value = "", onChange, className = "" }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    if (!open) return;
    function handleClick(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  if (!Array.isArray(players) || players.length === 0) return null;

  const selectedPlayer = players.find((player) => {
    const playerId = player?.userId || player?.socketId || player?.id || player?.username;
    return String(value) === String(playerId);
  });

  return (
    <div className={`relative w-full mb-2  ${className}`} ref={dropdownRef}>
      <button
        type="button"
        className="w-full flex items-center justify-between rounded-xl border border-sky-300 bg-white px-3 py-2 text-sm text-slate-900 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-sky-200 dark:focus:ring-sky-900"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span>
          Spectate {selectedPlayer?.username || "Player"}
        </span>
        <svg className={`ml-2 h-4 w-4 transition-transform ${open ? "rotate-180" : "rotate-0"}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" /></svg>
      </button>
      {open && (
        <ul
          className="absolute left-0 z-50 mt-2 max-h-56 w-full overflow-y-auto rounded-xl border border-sky-300 bg-white py-1 shadow-lg dark:border-slate-700 dark:bg-slate-950"
          tabIndex={-1}
          role="listbox"
        >
          {players.map((player) => {
            const playerId = player?.userId || player?.socketId || player?.id || player?.username;
            const selected = String(value) === String(playerId);
            return (
              <li
                key={playerId}
                className={`px-4 py-2 cursor-pointer text-sm ${selected ? "bg-sky-100 text-sky-900 dark:bg-sky-800 dark:text-white font-semibold" : "text-slate-900 hover:bg-sky-50 dark:text-slate-100 dark:hover:bg-sky-900"}`}
                onClick={() => {
                  setOpen(false);
                  onChange && onChange(playerId);
                }}
                role="option"
                aria-selected={selected}
              >
                Spectate {player?.username || "Player"}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

export default SpectatorPerspectiveSelector;